export default __webpack_public_path__ + "chrome-extension-login.png";